import React, { Component } from 'react'
import * as actions from '../../store/actions'
import { connect } from 'react-redux'
import Step from '@material-ui/core/Step'
import Stepper from '@material-ui/core/Stepper'
import StepLabel from '@material-ui/core/StepLabel'
import ZakupLicencjiWariant from './ZakupLicencjiWariant'
import ZakupLicencjiDaneDoFaktury from './ZakupLicencjiDaneDoFaktury'
import ZakupLicencjiPlatnosc from './ZakupLicencjiPlatnosc'
import ZakupLicencjiStyle from '../../styles/ZakupLicencjiStyle'
import ClearIcon from '@material-ui/icons/Clear'
import Button from '@material-ui/core/Button'
import zaokragl from '../../lib/mathUtils'

class ZakupLicencji extends Component {
  kroki = ['Wariant licencji', 'Dane do faktury', 'Płatność']
  state = {
    krok: 0,
    wariantLicencji: null,
    nazwaFirmy: '',
    NIP: '',
    ulica: '',
    nrDomu: '',
    nrLokalu: '',
    miejscowosc: '',
    kodPocztowy: '',
    poczta: '',
    emailDoFaktury: '',
    zgodaNaEmailDoFaktury: false,
    gusError: false,
    gusServerError: false,
    validateErrors: [],
  }

  getGUSData = nip => {
    if (nip) {
      this.props.onLoadGUS(nip).then(res => {
        const { daneGUS, gusServerError } = res
        if (daneGUS) {
          let kod = daneGUS.AdresSiedziby.KodPocztowy
          if (kod && kod.length === 5)
            kod = kod.substring(0, 2) + '-' + kod.substring(2, 5)
          this.setState({
            nazwaFirmy: daneGUS.NazwaPelna,
            ulica: daneGUS.AdresSiedziby.Ulica,
            nrDomu: daneGUS.AdresSiedziby.NrDomu,
            nrLokalu: daneGUS.AdresSiedziby.NrLokalu,
            miejscowosc: daneGUS.AdresSiedziby.Miejscowosc,
            kodPocztowy: kod,
            poczta: daneGUS.AdresSiedziby.Poczta,
          })
        } else this.setState({ gusError: true, gusServerError })
        this.props.onSetGUSLoading(false)
      })
    }
  }

  changeData = (name, value) => {
    this.setState({ [name]: value })
  }

  getWariantInt = wariant => {
    switch (wariant) {
      case 'Firma':
        return 1
      case 'Biuro rachunkowe':
        return 2
      case 'Licencja Premium':
        return 3
      default:
        return 0
    }
  }

  handleSelect = (variant, price) => {
    this.setState(state => ({
      wariantLicencji: {
        wariantText: variant,
        wariantInt: this.getWariantInt(variant),
        cenaNetto: price,
        cenaBrutto: zaokragl(price * 1.23),
      },
      krok: state.krok + 1,
    }))
  }

  validMail(mail) {
    return /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>().,;\s@"]+\.{0,1})+([^<>().,;:\s@"]{2,}|[\d.]+))$/.test(
      mail,
    )
  }

  daneDoFakturyValidate = () => {
    let errors = []
    if (!this.state.NIP) {
      errors.push({ NazwaPola: 'NIP' })
    }
    if (!this.state.nazwaFirmy) {
      errors.push({ NazwaPola: 'nazwaFirmy' })
    }
    if (!this.state.nrDomu) {
      errors.push({ NazwaPola: 'nrDomu' })
    }
    if (!this.state.miejscowosc) {
      errors.push({ NazwaPola: 'miejscowosc' })
    }
    if (!this.state.emailDoFaktury) {
      errors.push({ NazwaPola: 'emailDoFaktury' })
    }
    if (!this.validMail(this.state.emailDoFaktury)) {
      errors.push({ NazwaPola: 'emailDoFaktury' })
    }
    if (!this.state.zgodaNaEmailDoFaktury) {
      errors.push({ NazwaPola: 'zgodaNaEmailDoFaktury' })
    }
    this.setState({ validateErrors: errors })
    return errors.length === 0
  }

  handleNextStep = () => {
    if (this.state.krok === 1) {
      if (!this.daneDoFakturyValidate()) return
    }
    this.setState(state => ({
      krok: state.krok + 1,
    }))
  }

  handlePrevStep = () => {
    this.setState(state => ({
      krok: state.krok - 1,
    }))
  }

  handlePayment = () => {
    let adres = ''
    if (this.state.ulica) adres = this.state.ulica + ' ' + this.state.nrDomu
    else adres = this.state.miejscowosc + ' ' + this.state.nrDomu
    if (this.state.nrLokalu) adres += ' / ' + this.state.nrLokalu
    this.props.onRegisterPayment({
      email: this.props.licencja.email,
      NIP: this.state.NIP,
      nazwaFirmy: this.state.nazwaFirmy,
      ulica: this.state.ulica,
      nrDomu: this.state.nrDomu,
      nrLokalu: this.state.nrLokalu,
      miejscowosc: this.state.miejscowosc,
      kodPocztowy: this.state.kodPocztowy,
      poczta: this.state.poczta,
      adresZbiorczy: adres,
      wariantLicencji: this.state.wariantLicencji,
      emailDoFaktury: this.state.emailDoFaktury,
    })
  }

  render = () => {
    return (
      <ZakupLicencjiStyle>
        <section>
          <header>
            <div className="high-headline-5">ZAKUP LICENCJI</div>
            <div className="imgContainerSmall" onClick={this.props.onCancel}>
              <ClearIcon />
            </div>
          </header>
          <div className="steper">
            <Stepper activeStep={this.state.krok} alternativeLabel>
              {this.kroki.map(label => {
                return (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                )
              })}
            </Stepper>
          </div>
          <main>
            {this.state.krok === 0 && (
              <ZakupLicencjiWariant onSelect={this.handleSelect} />
            )}
            {this.state.krok === 1 && (
              <ZakupLicencjiDaneDoFaktury
                data={{ ...this.state }}
                validateErrors={this.state.validateErrors}
                onChangeData={this.changeData}
                onGetGUSData={this.getGUSData}
                isGUSLoading={this.props.isGUSLoading}
                gusError={this.state.gusError}
                gusServerError={this.state.gusServerError}
                onCloseGUSErrorDialog={() => {
                  this.setState({ gusError: false, gusServerError: false })
                }}
              />
            )}
            {this.state.krok === 2 && (
              <ZakupLicencjiPlatnosc
                data={{ ...this.state }}
                onPay={this.handlePayment}
              />
            )}
          </main>
          {this.state.krok === 1 && (
            <footer>
              <Button
                variant="outlined"
                color="primary"
                onClick={this.handlePrevStep}
              >
                WSTECZ
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleNextStep}
              >
                DALEJ
              </Button>
            </footer>
          )}
          {this.state.krok === 2 && (
            <footer>
              <Button
                variant="outlined"
                color="primary"
                onClick={this.handlePrevStep}
              >
                WSTECZ
              </Button>
            </footer>
          )}
        </section>
      </ZakupLicencjiStyle>
    )
  }
}

const mapStateToProps = state => {
  return {
    licencja: state.sprawozdanie.licencja,
    isGUSLoading: state.sprawozdanie.isGUSLoading,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onCancel: () => dispatch(actions.setZakupLicencji(false)),
    onLoadGUS: identyfikator =>
      dispatch(actions.loadGUS(false, identyfikator, false)),
    onSetGUSLoading: isGUSLoading =>
      dispatch(actions.setGUSLoading(isGUSLoading)),
    onRegisterPayment: data => dispatch(actions.registerPayment(data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ZakupLicencji)
